import serpApi from '@/app/Serp/api/serpApi';
import type {
  DeleteSerpHistoryRequest,
  SerpHistoryRequest,
  SerpHistoryResponse,
  SerpIdRequest,
  SerpStatusResponse,
  StartSerpRequest,
  StartSerpResponse
} from '@/app/Serp/types/serpApiTypes';
import type { ApiResponse } from '@/app/common/types/common';

const historyApi = serpApi.injectEndpoints({
  endpoints: build => ({
    startSerpGetting: build.mutation<StartSerpResponse, StartSerpRequest>({
      query: body => ({
        url: `/serp/v2/send_request_and_get_serp`,
        method: 'POST',
        body
      })
    }),
    getSerpHistory: build.query<SerpHistoryResponse, SerpHistoryRequest>({
      query: body => ({
        url: `/serp/v2/history/`,
        method: 'POST',
        body
      }),
      providesTags: ['SerpHistory'],
      keepUnusedDataFor: 3
    }),
    getStatusSerp: build.query<SerpStatusResponse, SerpIdRequest>({
      query: body => ({
        url: `/serp/v2/status`,
        method: 'POST',
        body
      }),
      providesTags: ['SerpStatus']
    }),
    deleteHistorySerp: build.mutation<
      ApiResponse<unknown>,
      DeleteSerpHistoryRequest
    >({
      query: body => ({
        url: `/serp/v2/delete`,
        method: 'POST',
        body: {
          serp_id: body.serp_id,
          requested_user: body.requested_user,
          domain_slug: body.domain_slug
        }
      })
    })
  })
});

export const {
  useDeleteHistorySerpMutation,
  useGetSerpHistoryQuery,
  useStartSerpGettingMutation,
  useGetStatusSerpQuery
} = historyApi;

export default historyApi;
